import messages from "@/api/messages.js"
export default {
    data() {
        return {
            messages : messages,
        };
    },
    // created() {
    //
    // },
    // computed: {
    //
    // },
    // methods: {
    // },
};
